import { formatRawProfiles, groupByProfileName } from "./useAmazonProfiles";
import AmazonProfilesTable from "./AmazonProfilesTable";
import { css } from "../../../../styled-system/css";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "zodios/client";

const useMissingTrellisAdsProfiles = () => {
  return useQuery({
    queryKey: [{ entity: "missingTrellisProfiles" }],
    queryFn: async () => await apiClient.getMissingAdvertisingProfiles(),
  });
};

const MissingProfilesSections = () => {
  const { data: missingProfilesData, isLoading: isMissingProfilesDataLoading } = useMissingTrellisAdsProfiles();

  const { profiles_missing_write_access, profiles_with_invalid_payment_methods } = missingProfilesData ?? {};

  const profilesMissingWriteAccess = formatRawProfiles(groupByProfileName(profiles_missing_write_access));
  const profilesWithInvalidPaymentMethods = formatRawProfiles(
    groupByProfileName(profiles_with_invalid_payment_methods),
  );

  if (isMissingProfilesDataLoading) {
    return null;
  }

  return (
    <>
      {profilesMissingWriteAccess.length ?
        <div className={css({ width: "100%" })}>
          <h3 className={css({ fontSize: "xxlarge", fontWeight: 600 })}>Profiles Missing Write Access</h3>
          <AmazonProfilesTable
            tableData={profilesMissingWriteAccess}
            columnsToRender={["marketplaces", "profile_type"]}
            isLoading={isMissingProfilesDataLoading}
            defaultSorted={[{ id: "name", desc: false }]}
          />
        </div>
      : null}
      {profilesWithInvalidPaymentMethods.length ?
        <div className={css({ width: "100%" })}>
          <h3 className={css({ fontSize: "xxlarge", fontWeight: 600 })}>Profiles With Invalid Payment Methods</h3>
          <AmazonProfilesTable
            tableData={profilesWithInvalidPaymentMethods}
            columnsToRender={["marketplaces", "profile_type"]}
            isLoading={isMissingProfilesDataLoading}
            defaultSorted={[{ id: "name", desc: false }]}
          />
        </div>
      : null}
    </>
  );
};

export default MissingProfilesSections;
